export default __webpack_public_path__ + "static/index-jenkins-9f039edc3cbe5d2ddc296ba0bbcbc12f.svg";